// Mock data for Sloomx Portfolio

export const portfolioData = {
  name: "Sloomx",
  fullName: "Salem",
  tagline: "Where art meets cinema",
  bio: "Passionate video editor and graphic designer with 5 years of experience in art and cinema. I bring your visions to life through captivating visuals and storytelling.",
  email: "saloom.info@gmail.com",
  phone: "+966544676955",
  linkedin: "https://www.linkedin.com/in/salem-hakami",
  
  experience: [
    {
      id: 1,
      title: "Video Editor",
      company: "SAN International Company Limited, Jeddah",
      period: "Nov 2025 - Present",
      bullets: [
        "Edited and produced high-quality video content for various projects, ensuring alignment with the company's creative vision and brand identity.",
        "Collaborated with teams to deliver visually compelling narratives that meet client expectations and project deadlines.",
        "Managed multiple projects simultaneously, maintaining attention to detail and delivering results under tight deadlines."
      ]
    },
    {
      id: 2,
      title: "Graphic Designer",
      company: "Peaks Team",
      period: "Oct 2023 - Apr 2024",
      bullets: [
        "Designed high-quality visual content for a highly skilled content creation team dedicated to achieving excellence and professionalism in the Saudi Arabian market.",
        "Collaborated with the team to ensure visual alignment with the mission to grow and become a market leader."
      ]
    },
    {
      id: 3,
      title: "Graphic Designer",
      company: "Formula 1, Medan Co., Jeddah",
      period: "Jan 2021 - Mar 2023",
      bullets: [
        "Created captivating and immersive experiences through graphic design for a company specializing in the innovative entertainment industry.",
        "Successfully delivered fast-paced design assets for a major Formula 1 event, demonstrating the ability to manage projects under tight deadlines."
      ]
    },
    {
      id: 4,
      title: "Digital Designer",
      company: "KAUST (King Abdullah University of Science and Technology), KAEC",
      period: "Apr 2022 - May 2022",
      bullets: [
        "Provided digital design support for the research university focused on STEM fields (Science, Technology, Engineering, and Mathematics)."
      ]
    },
    {
      id: 5,
      title: "Graphic Designer / Art Director",
      company: "Ewan, Jeddah",
      period: "Feb 2019 - Dec 2020",
      bullets: [
        "Served as an Art Director, responsible for communicating and presenting design concepts and ideas to various clients and stakeholders.",
        "Ensured all creative output remained current by consistently keeping up-to-date with design trends and industry best practices."
      ]
    }
  ],
  
  skills: [
    "Video Editing",
    "Color Grading",
    "Storytelling",
    "Adobe Premiere Pro",
    "After Effects",
    "DaVinci Resolve"
  ],
  
  videos: [
    {
      id: 1,
      title: "لعبه الكذابين مع الأصدقاء | 😎😂",
      youtubeId: "SfdYZbNl_fU",
      channel: "كعيب | ko3ib",
      category: "Entertainment"
    },
    {
      id: 2,
      title: "ابعد كرفان خلال 24 ساعة ! ⌛️",
      youtubeId: "Jyhw1q5361g",
      channel: "R8 Zone",
      category: "Challenge"
    },
    {
      id: 3,
      title: "اشرس زعيم للمافيا الإيطالية .. مرعب عصابات نيويورك !!",
      youtubeId: "nt77Wt-OrlI",
      channel: "فيصل غالب | Faisal Ghalib",
      category: "Documentary"
    },
    {
      id: 4,
      title: "تحدي اعرف الايموجي 🤔 ( مع اعضاء R8🤣)",
      youtubeId: "5qXJnejXbRY",
      channel: "كعيب | ko3ib",
      category: "Entertainment"
    },
    {
      id: 5,
      title: "لعبنا غميضة في جزيرة مهجورة 🏝️🤫",
      youtubeId: "DZityRYhCFQ",
      channel: "ريكو R0o08",
      category: "Adventure"
    },
    {
      id: 6,
      title: "#سلسلة_كيس | العودة التاريخيه 😎👍",
      youtubeId: "pqwAUaJg7Oo",
      channel: "كعيب | ko3ib",
      category: "Series"
    },
    {
      id: 7,
      title: "#1 الطريق إلى نهائي دوري ابطال أوروبا مجانا 🤯🏆",
      youtubeId: "FVs70UHyh5c",
      channel: "كارزما \\ KaRZmA",
      category: "Sports"
    },
    {
      id: 8,
      title: "قول بس لا تقول مع صناع محتوى R8 | 😂🤔",
      youtubeId: "qP5ppeaDj3U",
      channel: "كعيب | ko3ib",
      category: "Entertainment"
    },
    {
      id: 9,
      title: "اعضاء باور يجربون اخطر وظيفة في العالم! ( المطافي 🔥🚒 )",
      youtubeId: "O7TjTeZOiao",
      channel: "POWR eSports | باور",
      category: "Challenge"
    },
    {
      id: 10,
      title: "أبشع جريمة هزّت كوريا الجنوبية .. سفّاحة التاكسي !!",
      youtubeId: "7MsTxWpROg4",
      channel: "فيصل غالب | Faisal Ghalib",
      category: "Documentary"
    },
    {
      id: 11,
      title: "اخطر رجل مخدرات في أمريكا .. غيّر اللعبة واختفى بـ100 مليون !!",
      youtubeId: "zgcfOoa5vm8",
      channel: "فيصل غالب | Faisal Ghalib",
      category: "Documentary"
    },
    {
      id: 12,
      title: "سرق دولة كاملة واختفى .. ووزّع الملايين على مشاهير هوليوود !!",
      youtubeId: "THg3qDc8NyE",
      channel: "فيصل غالب | Faisal Ghalib",
      category: "Documentary"
    },
    {
      id: 13,
      title: "مجانين القمار .. سرقوا 29 ملهى ليلي أمريكي واختفوا كالأشباح !!",
      youtubeId: "6u2BHsJRwg4",
      channel: "فيصل غالب | Faisal Ghalib",
      category: "Documentary"
    },
    {
      id: 14,
      title: "اذكى عملية سرقة في التاريخ .. كيف خدع المجرمون الشرطة بعبقرية !!",
      youtubeId: "gs7oFLrUOnI",
      channel: "فيصل غالب | Faisal Ghalib",
      category: "Documentary"
    },
    {
      id: 15,
      title: "كيف اهان رجل واحد المافيا الإيطالية .. وسيطر على سوق المخدرات !!",
      youtubeId: "GvQ3-LdMp6s",
      channel: "فيصل غالب | Faisal Ghalib",
      category: "Documentary"
    },
    {
      id: 16,
      title: "اللاعب اللي أرعب كازينوهات لاس فيغاس .. ربح الملايين وطردوه للأبد !!",
      youtubeId: "ckFmcr_BNGE",
      channel: "فيصل غالب | Faisal Ghalib",
      category: "Documentary"
    },
    {
      id: 17,
      title: "#سلسلة_كيس | الهبد التاريخي 🤣",
      youtubeId: "34ttPSHd67Q",
      channel: "كعيب | ko3ib",
      category: "Series"
    },
    {
      id: 18,
      title: "اصعب يوم في حياتي !🤯 ( عشت في جزيرة مهجورة🏝)",
      youtubeId: "Pin_K4VUEHc",
      channel: "ريكو R0o08",
      category: "Adventure"
    },
    {
      id: 19,
      title: "فلوق الرجعة للرياض ✈️ ( مع اعضاء R8 )",
      youtubeId: "NjbxqLgOaR0",
      channel: "Loco brothers",
      category: "Vlog"
    },
    {
      id: 21,
      title: "ردة فعل اتحادي 🟡 ( مباراة الهلال vs الاتحاد ) تعبت خلااااص 💔!!!",
      youtubeId: "F97rKZB3DeQ",
      channel: "كارزما \\ KaRZmA",
      category: "Sports"
    },
    {
      id: 22,
      title: "اول فلوق😍 , يارب دعوات الغالية تستجاب😂🔥 #vlog1",
      youtubeId: "k2FyEeh9xjw",
      channel: "عبدالله الشهراني🇸🇦",
      category: "Vlog"
    },
    {
      id: 23,
      title: "لعبة سعودية - ياخي ما ابي اروح العزيمة خلاص سلمت عليكم Azooma Escape",
      youtubeId: "XAFnzA8jHG0",
      channel: "Shojjo 787",
      category: "Gaming"
    },
    {
      id: 24,
      title: "محاولات الصعود الى القمة PEAK",
      youtubeId: "ny2uj1DKwCI",
      channel: "Shojjo 787",
      category: "Gaming"
    },
    {
      id: 25,
      title: "ايش التضحيات اللي سوينها علشان ممكن نوصل PEAK",
      youtubeId: "gdCuNBiT2Ys",
      channel: "Shojjo 787",
      category: "Gaming"
    },
    {
      id: 26,
      title: "مستحيل نفوز في اللعبة هذي - R.E.P.O.",
      youtubeId: "SWh0GijICoI",
      channel: "Shojjo 787",
      category: "Gaming"
    },
    {
      id: 27,
      title: "لما نحاول نسرق وندخل بيوت مسكونه Dark Hours",
      youtubeId: "7xceLxq6LKw",
      channel: "Shojjo 787",
      category: "Gaming"
    }
  ],
  
  // Graphic Design Work
  designWork: [
    {
      id: 1,
      title: "Cinematic Story Design",
      category: "Cinematic",
      image: "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=1440,h=829,fit=crop/Awv8e2Mzw3cr9aML/story-25.2-Yle4DzKvwrI5nDgO.png",
      description: "Cinematic visual storytelling with dramatic composition"
    },
    {
      id: 2,
      title: "Story Scene 28",
      category: "Cinematic",
      image: "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=768,h=439,fit=crop/Awv8e2Mzw3cr9aML/story-28-YNqM9Zg2MEI0L1Bo.png",
      description: "Atmospheric scene design with depth"
    },
    {
      id: 3,
      title: "Story Scene 45",
      category: "Cinematic",
      image: "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=768,h=439,fit=crop/Awv8e2Mzw3cr9aML/story-45-A1azoDXOBgUP2aOx.png",
      description: "Dynamic visual narrative"
    },
    {
      id: 4,
      title: "Story Scene 37",
      category: "Cinematic",
      image: "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=768,h=439,fit=crop/Awv8e2Mzw3cr9aML/story-37.222-mp84ezKQvocPxnrO.png",
      description: "Cinematic composition"
    },
    {
      id: 5,
      title: "Story Scene 46",
      category: "Cinematic",
      image: "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=768,h=439,fit=crop/Awv8e2Mzw3cr9aML/story-46-AzGMEkWnanT56XEZ.png",
      description: "Visual storytelling design"
    },
    {
      id: 6,
      title: "Team Grid Design",
      category: "Simplistic",
      image: "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=1440,h=876,fit=crop/Awv8e2Mzw3cr9aML/artboard-2-copy-12-mnl4ZzVqLXiEPn7r.png",
      description: "Clean, minimal grid layout"
    },
    {
      id: 7,
      title: "Grid Layout 1",
      category: "Simplistic",
      image: "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=768,h=770,fit=crop/Awv8e2Mzw3cr9aML/grid-1-AVLxWGkQbGtZlEoZ.png",
      description: "Minimalist grid composition"
    },
    {
      id: 8,
      title: "Grid Layout 2",
      category: "Simplistic",
      image: "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=768,h=770,fit=crop/Awv8e2Mzw3cr9aML/grid-1.3-m7VDqB495EUx7xeK.png",
      description: "Simple design elements"
    },
    {
      id: 9,
      title: "Fan Art 3D",
      category: "3D",
      image: "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=1440,h=876,fit=crop/Awv8e2Mzw3cr9aML/fan-art-AoP4nz3l42i2j2kl.png",
      description: "3D character illustration"
    },
    {
      id: 10,
      title: "Fan Art Portrait",
      category: "3D",
      image: "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=768,h=1024,fit=crop/Awv8e2Mzw3cr9aML/fan-art2-dOqZr3QljPfyWQ6V.png",
      description: "3D portrait design"
    },
    {
      id: 11,
      title: "Fuel Refill Station",
      category: "3D",
      image: "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=1024,h=576,fit=crop/Awv8e2Mzw3cr9aML/fuel-refill-1-Yan0O3NvVnCpBwJe.png",
      description: "3D environment design"
    },
    {
      id: 12,
      title: "3D Scene Design",
      category: "3D",
      image: "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=1024,h=576,fit=crop/Awv8e2Mzw3cr9aML/8100cfa2-9fc5-4782-ab0d-cc1e194cd107_rw_1920-A0xvgglBN8ugvwR3.png",
      description: "Atmospheric 3D artwork"
    },
    {
      id: 13,
      title: "Cartoonish Character",
      category: "Cartoonish",
      image: "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=1440,h=565,fit=crop/Awv8e2Mzw3cr9aML/d93c3f8e-9fdf-45e9-8635-14b019b76bbe_rw_1920-mk340PXZ7pSBrj3g.png",
      description: "Playful cartoon style design"
    },
    {
      id: 14,
      title: "Cartoon Scene 1",
      category: "Cartoonish",
      image: "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=768,h=453,fit=crop/Awv8e2Mzw3cr9aML/c5c8b411-964b-429a-a9d3-08ec7417b632_rw_1920-1-mePg04jleOUlaqZ9.png",
      description: "Vibrant cartoon illustration"
    },
    {
      id: 15,
      title: "Cartoon Scene 2",
      category: "Cartoonish",
      image: "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=768,h=453,fit=crop/Awv8e2Mzw3cr9aML/47b5fe40-af1b-49c2-a21c-d067cbd69f2c_rw_1920-AoP4zM7jBqCBa738.png",
      description: "Animated style artwork"
    }
  ],
  
  // Art Projects
  artProjects: [
    {
      id: 1,
      slug: "purple-soul",
      title: "Purple Soul",
      image: "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=768,h=487,fit=crop/Awv8e2Mzw3cr9aML/8100cfa2-9fc5-4782-ab0d-cc1e194cd107_rw_1920-A0xvgglBN8ugvwR3.png",
      description: "An atmospheric art project exploring depth and emotion through ethereal purple tones and cinematic composition.",
      gallery: [
        "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=1920,h=1080,fit=crop/Awv8e2Mzw3cr9aML/936ffbcf-3f4f-4f73-a8c2-83b34957a026_rw_1920-YrD4oo4ogvswwBy7.png",
        "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=1920,h=1080,fit=crop/Awv8e2Mzw3cr9aML/487992f8-82aa-4eb6-a64f-9eb58b94f486_rw_1920-dJoPr88Bl0TQVP5O.png",
        "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=1920,h=1080,fit=crop/Awv8e2Mzw3cr9aML/4f9a828a-1472-4ad1-9805-bb5fac70d8f3_rw_1920-mePgk00G56C1aVXW.png",
        "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=1920,h=1080,fit=crop/Awv8e2Mzw3cr9aML/8100cfa2-9fc5-4782-ab0d-cc1e194cd107_rw_1920-A0xvgglBN8ugvwR3.png"
      ]
    },
    {
      id: 2,
      slug: "alienated",
      title: "Alienated",
      image: "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=768,h=487,fit=crop/Awv8e2Mzw3cr9aML/464e6eae-a75d-4bc8-8391-b631efd29b85_rw_1920-AQEevve43zfDWa5q.png",
      description: "A journey through isolation and discovery, where neon greens and deep purples paint a story of disconnection.",
      gallery: [
        "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=1920,h=1080,fit=crop/Awv8e2Mzw3cr9aML/39f08c60-01bf-4342-b762-210054a4ba5e_rw_1920-m2Wq55xGlrc2G1Oz.png",
        "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=1920,h=1080,fit=crop/Awv8e2Mzw3cr9aML/9276a50d-8299-4fcb-b488-def4ce3a6a33_rw_1920-YX4jwwjzb6fDLLpn.png",
        "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=1920,h=1080,fit=crop/Awv8e2Mzw3cr9aML/464e6eae-a75d-4bc8-8391-b631efd29b85_rw_1920-AQEevve43zfDWa5q.png"
      ]
    },
    {
      id: 3,
      slug: "r8-ruins",
      title: "R8 Ruins",
      image: "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=768,h=487,fit=crop/Awv8e2Mzw3cr9aML/c713ac1c-69a8-4bcb-aee0-4c2e86a52653_rw_1920-mnl4yz7q1gI38zZr.png",
      description: "Exploring abandoned spaces and forgotten stories through cinematic visual storytelling.",
      gallery: [
        "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=1920,h=1080,fit=crop/Awv8e2Mzw3cr9aML/89e05e16-d2f5-440b-9ed1-2991c254e42d_rw_1920-YD0EnaDyN9sqqOX0.png",
        "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=1920,h=1080,fit=crop/Awv8e2Mzw3cr9aML/8e05aae0-1b85-4825-a802-4bcaddc2ec3f_rw_1920-dWxLaGwyk7t8gkNQ.png",
        "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=1920,h=1080,fit=crop/Awv8e2Mzw3cr9aML/c713ac1c-69a8-4bcb-aee0-4c2e86a52653_rw_1920-mnl4yz7q1gI38zZr.png",
        "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=1920,h=1080,fit=crop/Awv8e2Mzw3cr9aML/051e4167-3541-4c1b-bfa5-47bbb3922290_rw_1920-m5K8xe2bWPhVoX1d.png"
      ]
    },
    {
      id: 4,
      slug: "smiley-face",
      title: "Smiley Face",
      image: "https://assets.zyrosite.com/Awv8e2Mzw3cr9aML/1_1-AoP4ynykWVivO7jQ.gif",
      description: "An animated expression of joy and creativity, blending playful motion with bold visual design.",
      gallery: [
        "https://assets.zyrosite.com/Awv8e2Mzw3cr9aML/3-mePgkOxEjXc9EN7P.gif",
        "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=1920,h=1280,fit=crop/Awv8e2Mzw3cr9aML/1-YX4jwWaPQ0sexD78.png",
        "https://assets.zyrosite.com/Awv8e2Mzw3cr9aML/2-YKb8wLER06fBX7rx.gif",
        "https://assets.zyrosite.com/Awv8e2Mzw3cr9aML/1-AE07X5oZk1tpGG56.gif",
        "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=1920,h=1280,fit=crop/Awv8e2Mzw3cr9aML/3112222-A0xvgovL6WHyRrk4.png",
        "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=1920,h=1280,fit=crop/Awv8e2Mzw3cr9aML/4-AGBzoLz6x2UJlrBL.png"
      ]
    },
    {
      id: 5,
      slug: "small-world",
      title: "Small World",
      image: "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=768,h=490,fit=crop/Awv8e2Mzw3cr9aML/1-Yg24kgRQJXcngM18.png",
      description: "A miniature universe of stories, where every frame contains an entire world of imagination.",
      gallery: [
        "https://assets.zyrosite.com/Awv8e2Mzw3cr9aML/d0e2d8af-ce1b-4c8c-a398-20e09265602d_rw_1200-1-AQEevvPOyriM6jqE.gif",
        "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=1920,h=1080,fit=crop/Awv8e2Mzw3cr9aML/1-Yg24kgRQJXcngM18.png"
      ]
    },
    {
      id: 6,
      slug: "wrath-of-the-beast",
      title: "Wrath of the Beast",
      image: "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=768,h=487,fit=crop/Awv8e2Mzw3cr9aML/1-Yle4kDla1Bu4NVPO.png",
      description: "A dark and powerful visual narrative, channeling primal energy through striking imagery and motion.",
      gallery: [
        "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=1920,h=1350,fit=crop/Awv8e2Mzw3cr9aML/1-AR014567KjiXaa1g.png",
        "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=1920,h=1080,fit=crop/Awv8e2Mzw3cr9aML/2-YyvDQEzokjT30W1g.png",
        "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=1920,h=1080,fit=crop/Awv8e2Mzw3cr9aML/3-YNqMV9vPZBhJNe1K.png",
        "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=1920,h=1080,fit=crop/Awv8e2Mzw3cr9aML/4-AGBzoLOn7VTkyQ2E.png",
        "https://assets.zyrosite.com/Awv8e2Mzw3cr9aML/test-min-m6L2x88B3ZSjNMkk.gif",
        "https://assets.zyrosite.com/Awv8e2Mzw3cr9aML/l-AoP4yDlOOoT4aBzV.gif",
        "https://assets.zyrosite.com/Awv8e2Mzw3cr9aML/5.1-YD0Enr9V8qFVxgay.gif",
        "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=1920,h=1600,fit=crop/Awv8e2Mzw3cr9aML/8-ALp2w8pV84u9vGVL.png",
        "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=1920,h=1400,fit=crop/Awv8e2Mzw3cr9aML/9-YBgjMEx0PBHROg7L.png",
        "https://assets.zyrosite.com/Awv8e2Mzw3cr9aML/f1ac52ae-fb29-4678-b1be-8d4816127df5_rw_1920-1-Yan0D76zr6Co28NJ.gif",
        "https://assets.zyrosite.com/Awv8e2Mzw3cr9aML/test-2-min-AGBzoqqRVLiDgwP9.gif",
        "https://assets.zyrosite.com/Awv8e2Mzw3cr9aML/2-copy-dWxLanGz24u9LOg5.gif"
      ]
    }
  ],
  
  categories: ["All", "Documentary", "Entertainment", "Gaming", "Sports", "Challenge", "Series", "Adventure", "Vlog"],
  
  designCategories: ["All", "Cinematic", "Simplistic", "3D", "Cartoonish"],
  
  // Fashion - Organized by Style Sections
  fashionSections: [
    {
      id: "editorial",
      title: "Editorial",
      description: "Cinematic fashion films exploring narrative through movement and light.",
      videos: [
        {
          id: 1,
          title: "Editorial 01",
          videoUrl: "https://customer-assets.emergentagent.com/job_video-editor-port-2/artifacts/xl1af1se_EAR006F010408%20%281%29_1.mp4.mov"
        },
        {
          id: 2,
          title: "Editorial 02",
          videoUrl: "https://customer-assets.emergentagent.com/job_video-editor-port-2/artifacts/9kozcmt2_EAR006F010408.mp4.mov"
        },
        {
          id: 3,
          title: "Editorial 03",
          videoUrl: "https://customer-assets.emergentagent.com/job_video-editor-port-2/artifacts/45bbdcnt_EAS014L011101%20%281%29.mp4"
        },
        {
          id: 16,
          title: "Editorial 04",
          videoUrl: "https://customer-assets.emergentagent.com/job_video-editor-port-2/artifacts/glrl78sy_ZAS749F060306-LS.mp4"
        },
        {
          id: 17,
          title: "Editorial 05",
          videoUrl: "https://customer-assets.emergentagent.com/job_video-editor-port-2/artifacts/2u1viub8_ZGS015W010301-LS.mp4"
        },
        {
          id: 18,
          title: "Editorial 06",
          videoUrl: "https://customer-assets.emergentagent.com/job_video-editor-port-2/artifacts/b6so86ae_ZGS016W011101-LS.mp4"
        },
        {
          id: 19,
          title: "Editorial 07",
          videoUrl: "https://customer-assets.emergentagent.com/job_video-editor-port-2/artifacts/wcssppbx_NAS048F060306%20-2.mov"
        },
        {
          id: 20,
          title: "Editorial 08",
          videoUrl: "https://customer-assets.emergentagent.com/job_video-editor-port-2/artifacts/d9eotfd1_NAS049M110211%202.mov"
        }
      ]
    },
    {
      id: "lookbook",
      title: "Lookbook",
      description: "Product-focused showcases highlighting style, texture, and form.",
      videos: [
        {
          id: 4,
          title: "Lookbook 01",
          videoUrl: "https://customer-assets.emergentagent.com/job_video-editor-port-2/artifacts/op1bujgf_SLAS152M110211.MP4.mov"
        },
        {
          id: 5,
          title: "Lookbook 02",
          videoUrl: "https://customer-assets.emergentagent.com/job_video-editor-port-2/artifacts/1uq5vwmt_VAS001M110811%20%281%29.mov"
        },
        {
          id: 10,
          title: "Lookbook 03",
          videoUrl: "https://customer-assets.emergentagent.com/job_video-editor-port-2/artifacts/udkt83a9_1.mp4"
        },
        {
          id: 11,
          title: "Lookbook 04",
          videoUrl: "https://customer-assets.emergentagent.com/job_video-editor-port-2/artifacts/hdfh9pn6_2.mp4"
        },
        {
          id: 21,
          title: "Lookbook 05",
          videoUrl: "https://customer-assets.emergentagent.com/job_video-editor-port-2/artifacts/9goihfn0_NLH087F0201.mp4"
        },
        {
          id: 29,
          title: "Lifestyle 01",
          videoUrl: "https://customer-assets.emergentagent.com/job_video-editor-port-2/artifacts/qy9y4z83_ZAS856M110811-LIFESTYLE-NO%20TAG.mp4"
        },
        {
          id: 30,
          title: "Lifestyle 02",
          videoUrl: "https://customer-assets.emergentagent.com/job_video-editor-port-2/artifacts/z6ayi4tj_ZAS887M110511-LIFESTYLE-NO%20TAG.mp4"
        },
        {
          id: 31,
          title: "Lifestyle 03",
          videoUrl: "https://customer-assets.emergentagent.com/job_video-editor-port-2/artifacts/ky22x4zh_ZAS888M113111-LIFESTYLE-NO%20TAG.mp4"
        },
        {
          id: 36,
          title: "Lookbook 06",
          videoUrl: "https://customer-assets-cm19k8pv.emergentagent.net/job_video-editor-port-2/artifacts/39fep9xm_NLH088F4401-PF-NO%20TAG.mp4"
        }
      ]
    },
    {
      id: "campaign",
      title: "Campaign",
      description: "Brand campaigns crafted with precision and visual impact.",
      videos: [
        {
          id: 12,
          title: "Campaign 01",
          videoUrl: "https://customer-assets.emergentagent.com/job_video-editor-port-2/artifacts/f3iumfgi_LBH050L0201_1.mp4"
        },
        {
          id: 13,
          title: "Campaign 02",
          videoUrl: "https://customer-assets.emergentagent.com/job_video-editor-port-2/artifacts/xzb7pz88_LBH058L0201.mp4"
        },
        {
          id: 14,
          title: "Campaign 03",
          videoUrl: "https://customer-assets.emergentagent.com/job_video-editor-port-2/artifacts/8n95hkzj_LBH058L7601.mp4"
        },
        {
          id: 15,
          title: "Campaign 04",
          videoUrl: "https://customer-assets.emergentagent.com/job_video-editor-port-2/artifacts/lo48dxv3_LBH005L310501.mp4"
        },
        {
          id: 28,
          title: "Campaign 05",
          videoUrl: "https://customer-assets.emergentagent.com/job_video-editor-port-2/artifacts/d0nmdmjh_ZAS855M110511-PF-R-NO%20TAG.mp4"
        }
      ]
    },
    {
      id: "couture",
      title: "Couture & Detail",
      description: "Intimate close-ups capturing the craft behind every stitch.",
      videos: [
        {
          id: 6,
          title: "Couture 01",
          videoUrl: "https://customer-assets.emergentagent.com/job_video-editor-port-2/artifacts/adi3q9pj_ZDS010M110811-STV-NO%20TAG.mp4"
        },
        {
          id: 7,
          title: "Couture 02",
          videoUrl: "https://customer-assets.emergentagent.com/job_video-editor-port-2/artifacts/otr11ryu_ZLD131W0701-TS-LS-NO%20TAG.mp4"
        },
        {
          id: 8,
          title: "Couture 03",
          videoUrl: "https://customer-assets.emergentagent.com/job_video-editor-port-2/artifacts/5w35tcsc_ZLD135W1601-TS-LS-NO%20TAG.mp4"
        },
        {
          id: 9,
          title: "Couture 04",
          videoUrl: "https://customer-assets.emergentagent.com/job_video-editor-port-2/artifacts/9oy3vmly_ZOS316F061106-TS-PF-NO%20TAG.mp4"
        },
        {
          id: 32,
          title: "Couture 05",
          videoUrl: "https://customer-assets.emergentagent.com/job_video-editor-port-2/artifacts/m3ijt3so_ZLD168W0201-PF-NO%20TAG.mp4"
        },
        {
          id: 33,
          title: "Couture 06",
          videoUrl: "https://customer-assets.emergentagent.com/job_video-editor-port-2/artifacts/q5vxa4a0_ZLD147W0707-PF-NO%20TAG.mp4"
        }
      ]
    },
    {
      id: "reels",
      title: "Reels & Social",
      description: "Short-form vertical content built for social engagement.",
      videos: [
        {
          id: 22,
          title: "Reel 01",
          videoUrl: "https://customer-assets.emergentagent.com/job_video-editor-port-2/artifacts/r2y55y7l_1%20tik.mp4"
        },
        {
          id: 23,
          title: "Reel 02",
          videoUrl: "https://customer-assets.emergentagent.com/job_video-editor-port-2/artifacts/pxhf3rga_1.mp4"
        },
        {
          id: 24,
          title: "Reel 03",
          videoUrl: "https://customer-assets.emergentagent.com/job_video-editor-port-2/artifacts/c5k5k9pn_3.mp4"
        },
        {
          id: 25,
          title: "Reel 04",
          videoUrl: "https://customer-assets.emergentagent.com/job_video-editor-port-2/artifacts/a6069449_4.mp4"
        },
        {
          id: 26,
          title: "Reel 05",
          videoUrl: "https://customer-assets.emergentagent.com/job_video-editor-port-2/artifacts/9h7viwdp_6.mp4"
        },
        {
          id: 27,
          title: "Reel 06",
          videoUrl: "https://customer-assets.emergentagent.com/job_video-editor-port-2/artifacts/vgx2ixjt_ZAS855M110411-TIKTOK-NO%20TAG.mp4"
        },
        {
          id: 34,
          title: "Reel 07",
          videoUrl: "https://customer-assets.emergentagent.com/job_video-editor-port-2/artifacts/wvqb1s0s_ZLP011W1111-TIKTOK-NO%20TAG.mp4"
        },
        {
          id: 35,
          title: "Reel 08",
          videoUrl: "https://customer-assets.emergentagent.com/job_video-editor-port-2/artifacts/61setw7l_ZLS084W0511-TIKTOK-NO%20TAG.mp4"
        },
        {
          id: 37,
          title: "Reel 09",
          videoUrl: "https://customer-assets-cm19k8pv.emergentagent.net/job_video-editor-port-2/artifacts/r0gffele_EOS109F010401-TIKTOK-NO%20TAG.mp4"
        },
        {
          id: 38,
          title: "Reel 10",
          videoUrl: "https://customer-assets-cm19k8pv.emergentagent.net/job_video-editor-port-2/artifacts/dxx51tf0_ZOB005W011601-TIKTOK-NO%20TAG.mp4"
        },
        {
          id: 39,
          title: "Reel 11",
          videoUrl: "https://customer-assets-cm19k8pv.emergentagent.net/job_video-editor-port-2/artifacts/4p47fxtw_ZAS893W060306-TIKTOK-NO%20TAG.mp4"
        },
        {
          id: 40,
          title: "Reel 12",
          videoUrl: "https://customer-assets-cm19k8pv.emergentagent.net/job_video-editor-port-2/artifacts/5dy51jow_ZOS407W061106-TIKTOK-NO%20TAG.mp4"
        },
        {
          id: 41,
          title: "Reel 13",
          videoUrl: "https://customer-assets-cm19k8pv.emergentagent.net/job_video-editor-port-2/artifacts/nfw1b61d_ZLD190W020701-TIKTOK-NO%20TAG.mp4"
        },
        {
          id: 42,
          title: "Reel 14",
          videoUrl: "https://customer-assets-cm19k8pv.emergentagent.net/job_video-editor-port-2/artifacts/rwmaf9i9_ZOB004W010801-TIKTOK-NO%20TAG.mp4"
        },
        {
          id: 43,
          title: "Reel 15",
          videoUrl: "https://customer-assets-cm19k8pv.emergentagent.net/job_video-editor-port-2/artifacts/31qkli20_ZOL089W010302-TIKTOK-NO%20TAG.mp4"
        },
        {
          id: 44,
          title: "Reel 16",
          videoUrl: "https://customer-assets-cm19k8pv.emergentagent.net/job_video-editor-port-2/artifacts/zohhz3wc_ZOB004W110311-TIKTOK-NO%20TAG.mp4"
        },
        {
          id: 45,
          title: "Reel 17",
          videoUrl: "https://customer-assets-cm19k8pv.emergentagent.net/job_video-editor-port-2/artifacts/urrmfbc3_ZOB005W110311-TIKTOK-NO%20TAG.mp4"
        },
        {
          id: 46,
          title: "Reel 18",
          videoUrl: "https://customer-assets-cm19k8pv.emergentagent.net/job_video-editor-port-2/artifacts/wqvyzv0g_ZAS898M110511-B-TIKTOK-NO%20TAG.mp4"
        },
        {
          id: 47,
          title: "Reel 19",
          videoUrl: "https://customer-assets-cm19k8pv.emergentagent.net/job_video-editor-port-2/artifacts/fc438avl_ZAS900M040204-TIKTOK-NO%20TAG.mp4"
        },
        {
          id: 48,
          title: "Reel 20",
          videoUrl: "https://customer-assets-cm19k8pv.emergentagent.net/job_video-editor-port-2/artifacts/bkzvw4md_ZLD146W252501-TIKTOK-NO%20TAG.mp4"
        },
        {
          id: 49,
          title: "Reel 21",
          videoUrl: "https://customer-assets-cm19k8pv.emergentagent.net/job_video-editor-port-2/artifacts/niet50d3_ZAS615M380438-TIKTOK-NO%20TAG.mp4"
        },
        {
          id: 50,
          title: "Reel 22",
          videoUrl: "https://customer-assets-cm19k8pv.emergentagent.net/job_video-editor-port-2/artifacts/qe3acfug_ZAS894W110311-TIKTOK-NO%20TAG.mp4"
        }
      ]
    }
  ],
  
  testimonials: [
    {
      id: 1,
      name: "Ahmed R.",
      role: "Content Creator",
      text: "Sloomx transformed our raw footage into cinematic masterpieces. His attention to detail and creative vision is unmatched.",
      rating: 5
    },
    {
      id: 2,
      name: "Fatima K.",
      role: "Marketing Director",
      text: "Working with Salem was a game-changer for our brand. His editing style brought our story to life in ways we never imagined.",
      rating: 5
    },
    {
      id: 3,
      name: "Mohammed S.",
      role: "YouTuber",
      text: "The quality of work and fast turnaround time is incredible. Highly recommend for anyone looking for professional video editing.",
      rating: 5
    }
  ]
};

// Mock function to save contact form
export const saveContactForm = async (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Contact form submitted (MOCK):', formData);
      resolve({ success: true, message: 'Message sent successfully!' });
    }, 1000);
  });
};
